<div class="header">
  <div class="title">Rename File</div>
  <button class="close-button" mat-icon-button (click)="discard()" [tabIndex]="-1">
    <mat-icon [svgIcon]="'close'"></mat-icon>
  </button>
</div>

<form [formGroup]="renameFileForm">
  <mat-form-field class="subject">
    <mat-label>File Name</mat-label>
    <input matInput [formControlName]="'name'" />
    <mat-error *ngIf="renameFileForm.get('name').hasError('required')"> File name is required </mat-error>
    <mat-error *ngIf="renameFileForm.get('name').hasError('minlength')">
      Please enter a name with at least 3 characters
    </mat-error>
  </mat-form-field>

  <div class="actions justify-end">
    <div class="buttons">
      <button class="discard-button" mat-button type="button" (click)="discard()">
        <span>Cancel</span>
      </button>
      <button
        class="send-button"
        mat-flat-button
        type="submit"
        [color]="'primary'"
        [disabled]="renameFileForm.pristine || renameFileForm.invalid"
        (click)="save()"
      >
        <span>Save</span>
      </button>
    </div>
  </div>
</form>
